var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNumberShine5(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 26 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#number-shine-5_svg__filter0_d_13479_88649)",
    clipRule: "evenodd",
    shapeRendering: "crispEdges"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6.244 7.012h13.334v6.498h-6.897l-.042.448a14.797 14.797 0 011.236-.055c1.31 0 2.519.308 3.603.94a6.43 6.43 0 012.545 2.655c.607 1.14.895 2.43.895 3.844 0 2.444-.747 4.46-2.36 5.888-1.597 1.423-3.914 2.043-6.761 2.043-2.426 0-4.495-.372-6.153-1.18l-.562-.275v-6.615l1.418.652a13.43 13.43 0 002.492.838c.957.226 1.736.328 2.354.328.876 0 1.394-.184 1.691-.414.248-.199.426-.51.426-1.101 0-.494-.16-.786-.437-1.004-.293-.23-.858-.43-1.872-.43-.723 0-1.534.137-2.44.43l-.387.126-2.948-1.464.865-12.152zm1.863 2l-.638 8.957 1.025.509c.921-.266 1.81-.406 2.66-.406 1.21 0 2.304.228 3.105.856.816.639 1.204 1.54 1.204 2.578 0 1.064-.358 2.011-1.184 2.669l-.008.006c-.779.608-1.8.84-2.925.84-.823 0-1.766-.134-2.814-.382H8.53c-.504-.12-.987-.257-1.448-.41v2.31c1.223.476 2.783.734 4.715.734 2.603 0 4.35-.573 5.432-1.537l.003-.002c1.084-.96 1.686-2.371 1.686-4.392 0-1.138-.23-2.097-.662-2.907l-.003-.006a4.43 4.43 0 00-1.769-1.85l-.01-.006c-.756-.442-1.614-.67-2.599-.67-.232 0-.49.008-.774.025h-.015l-.015.001c-.212.007-.648.065-1.359.201l-1.308.252.454-4.872h6.72V9.012h-9.47z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.244 7.012h13.334v6.498h-6.897l-.042.448a14.797 14.797 0 011.236-.055c1.31 0 2.519.308 3.603.94a6.43 6.43 0 012.545 2.655c.607 1.14.895 2.43.895 3.844 0 2.444-.747 4.46-2.36 5.888-1.597 1.423-3.914 2.043-6.761 2.043-2.426 0-4.495-.372-6.153-1.18l-.562-.275v-6.615l1.418.652a13.43 13.43 0 002.492.838c.957.226 1.736.328 2.354.328.876 0 1.394-.184 1.691-.414.248-.199.426-.51.426-1.101 0-.494-.16-.786-.437-1.004-.293-.23-.858-.43-1.872-.43-.723 0-1.534.137-2.44.43l-.387.126-2.948-1.464.865-12.152zm1.863 2l-.638 8.957 1.025.509c.921-.266 1.81-.406 2.66-.406 1.21 0 2.304.228 3.105.856.816.639 1.204 1.54 1.204 2.578 0 1.064-.358 2.011-1.184 2.669l-.008.006c-.779.608-1.8.84-2.925.84-.823 0-1.766-.134-2.814-.382H8.53c-.504-.12-.987-.257-1.448-.41v2.31c1.223.476 2.783.734 4.715.734 2.603 0 4.35-.573 5.432-1.537l.003-.002c1.084-.96 1.686-2.371 1.686-4.392 0-1.138-.23-2.097-.662-2.907l-.003-.006a4.43 4.43 0 00-1.769-1.85l-.01-.006c-.756-.442-1.614-.67-2.599-.67-.232 0-.49.008-.774.025h-.015l-.015.001c-.212.007-.648.065-1.359.201l-1.308.252.454-4.872h6.72V9.012h-9.47z",
    stroke: "#02A7DB",
    strokeOpacity: 0.6
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "number-shine-5_svg__filter0_d_13479_88649",
    x: 0.582,
    y: 2.512,
    width: 24.836,
    height: 31.262,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.00784314 0 0 0 0 0.654902 0 0 0 0 0.858824 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13479_88649"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_13479_88649",
    result: "shape"
  })))));
}

export default SvgNumberShine5;